import { render } from "./ComponentDetailCategory.vue?vue&type=template&id=358c56a3&scoped=true"
import script from "./ComponentDetailCategory.vue?vue&type=script&lang=js"
export * from "./ComponentDetailCategory.vue?vue&type=script&lang=js"

import "./ComponentDetailCategory.vue?vue&type=style&index=0&id=358c56a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358c56a3"]])

export default __exports__